import ShipsService from "@/services/ships.service";

const data = {
  maintainers: [],
  ships: {}, //active ships and before activation
  ships_all: [], //everything
  sla_licenses_list: [],
  cases_list: [],
  system_list: [],
  selectedMaintainer: {
    name: null,
    displayName: null,
  },

  toastData: {
    message: "",
    title: "",
    type: "",
  },
};

export const service = {
  namespaced: true,
  state: data,
  actions: {
    getMaintainersV2({ commit }, params) {
      return ShipsService.getMaintainersV2(params)
        .then(
          (result) => {
            commit("storeMaintainers", result.data.maintainers);
            return Promise.resolve(result);
          },
          (error) => {
            commit("errorToast", error);
            return Promise.reject(error.response);
          }
        )
        .catch((error) => {
          commit("errorToast", error);
          return Promise.reject(error.response);
        });
    },
    getShipsV2({ commit }, params) {
      return ShipsService.getShipsV2(params)
        .then(
          (result) => {
            result.data.maintainer = params.maintainer;
            commit("storeShips", result.data);
            return Promise.resolve(result);
          },
          (error) => {
            commit("errorToast", error);
            return Promise.reject(error.response);
          }
        )
        .catch((error) => {
          commit("errorToast", error);
          return Promise.reject(error.response);
        });
    },
    getShipsV2All({ commit }, params) {
      params.args = [
        "include_not_activated",
        "include_deactivated",
        "include_test",
      ];
      return ShipsService.getShipsV2(params)
        .then(
          (result) => {
            result.data.maintainer = params.maintainer;
            commit("storeShipsAll", result.data);
            return Promise.resolve(result);
          },
          (error) => {
            commit("errorToast", error);
            return Promise.reject(error.response);
          }
        )
        .catch((error) => {
          commit("errorToast", error);
          return Promise.reject(error.response);
        });
    },
    async LazyLoadShipsMoreData({ commit }, params) {
      let id_array = [];
      let index_look_up_array = [];
      const ship_count = this.state.service.ships[params.maintainer].length;
      for (const [index, element] of this.state.service.ships[
        params.maintainer
      ].entries()) {
        id_array.push(
          this.state.service.ships[params.maintainer][index].ship_id
        );
        index_look_up_array.push(index);
        if (id_array.length >= 50 || index >= ship_count - 1) {
          params.id_array = id_array.join(",");
          let result = await ShipsService.getShipServiceDetails(params).then(
            (result) => Promise.resolve(result)
          );
          if (
            params.watchdog_kpi !== undefined &&
            params.watchdog_kpi !== null
          ) {
            result.data.results.watchdog_kpi.forEach((data, index2) => {
              let kpi_data = {
                maintainer: params.maintainer,
                kpi: data.kpi,
                exclusion: data.exclusion,
                index: index_look_up_array[index2],
              };
              commit("storeShipWatchdogKpi", kpi_data);
            });
          }
          if (
            params.watchdog_exclusions !== undefined &&
            params.watchdog_exclusions !== null
          ) {
            result.data.results.watchdog_exclusions.forEach((data, index2) => {
              let exclusion_data = {
                maintainer: params.maintainer,
                index: index_look_up_array[index2],
                exclusions: data,
              };
              commit("storeShipWatchdogExclusions", exclusion_data);
            });
          }
          if (
            params.ship_tickets !== undefined &&
            params.ship_tickets !== null
          ) {
            result.data.results.ship_tickets.forEach((data, index2) => {
              let tickets_data = {
                maintainer: params.maintainer,
                index: index_look_up_array[index2],
                tickets: data,
              };
              commit("storeShipTickets", tickets_data);
            });
          }
          if (params.ship_cases !== undefined && params.ship_cases !== null) {
            result.data.results.ship_cases.forEach((data, index2) => {
              let ship_cases_data = {
                maintainer: params.maintainer,
                index: index_look_up_array[index2],
                cases: data,
              };
              commit("storeShipCases", ship_cases_data);
            });
          }
          if (
            params.ship_systems !== undefined &&
            params.ship_systems !== null
          ) {
            result.data.results.ship_systems.forEach((data, index2) => {
              let ship_systems_data = {
                maintainer: params.maintainer,
                index: index_look_up_array[index2],
                systems: data,
              };
              commit("storeShipSystems", ship_systems_data);
            });
          }
          if (
            params.ship_hardware !== undefined &&
            params.ship_hardware !== null
          ) {
            result.data.results.ship_hardware.forEach((data, index2) => {
              let ship_hardware_data = {
                maintainer: params.maintainer,
                index: index_look_up_array[index2],
                hardware: data,
              };
              commit("storeShipHardware", ship_hardware_data);
            });
          }
          if (
            params.ship_software !== undefined &&
            params.ship_software !== null
          ) {
            result.data.results.ship_software.forEach((data, index2) => {
              let ship_software_data = {
                maintainer: params.maintainer,
                index: index_look_up_array[index2],
                software: data,
              };
              commit("storeShipSoftware", ship_software_data);
            });
          }
          id_array = [];
          index_look_up_array = [];
        }
      }
      return Promise.resolve(true);
    },
    saveCase({ commit }, params) {
      return ShipsService.saveCase(params).then(
        (result) => Promise.resolve(result),
        (error) => {
          commit("errorToast", error);
          return Promise.reject(error.response);
        }
      );
    },
    createCase({ commit }, params) {
      return ShipsService.createCase(params).then(
        (result) => Promise.resolve(result),
        (error) => {
          commit("errorToast", error);
          return Promise.reject(error.response);
        }
      );
    },
    updateOrCreateSystem({ commit }, params) {
      return ShipsService.updateOrCreateSystem(params).then(
        (result) => Promise.resolve(result),
        (error) => {
          commit("errorToast", error);
          return Promise.reject(error);
        }
      );
    },
    shipCasesHistory({ commit }, params) {
      return ShipsService.getCases(params).then(
        (result) => {
          const data = {
            maintainer: params.maintainer,
            ship_id: params.ship_id,
            cases: result.data.cases,
          };
          commit("storeShipCasesHistory", data);
          return Promise.resolve(result);
        },
        (error) => {
          commit("errorToast", error);
          return Promise.reject(error.response);
        }
      );
    },
    shipExclusionsHistory({ commit }, params) {
      return ShipsService.getExclusions(params).then(
        (result) => {
          const data = {
            maintainer: params.maintainer,
            ship_id: params.ship_id,
            exclusions: result.data.exclusions,
          };
          commit("storeShipExclusionsHistory", data);
          return Promise.resolve(result);
        },
        (error) => {
          commit("errorToast", error);
          return Promise.reject(error.response);
        }
      );
    },
    shipSystemsHistory({ commit }, params) {
      return ShipsService.getSystemList(params).then(
        (result) => {
          const data = {
            maintainer: params.maintainer,
            ship_id: params.ship_id,
            systems: result.data.systems,
          };
          commit("storeShipSystemsHistory", data);
          return Promise.resolve(result);
        },
        (error) => {
          commit("errorToast", error);
          return Promise.reject(error.response);
        }
      );
    },
    shipHardwareHistory({ commit }, params) {
      return ShipsService.getHardwareList(params).then(
        (result) => {
          const data = {
            maintainer: params.maintainer,
            ship_id: params.ship_id,
            hardware: result.data.hardware_list,
          };
          commit("storeShipHardwareHistory", data);
          return Promise.resolve(result);
        },
        (error) => {
          commit("errorToast", error);
          return Promise.reject(error.response);
        }
      );
    },
    shipSoftwareHistory({ commit }, params) {
      return ShipsService.getSoftwareList(params).then(
        (result) => {
          const data = {
            maintainer: params.maintainer,
            ship_id: params.ship_id,
            software: result.data.software_list,
          };
          commit("storeShipSoftwareHistory", data);
          return Promise.resolve(result);
        },
        (error) => {
          commit("errorToast", error);
          return Promise.reject(error.response);
        }
      );
    },
    getSLAList({ commit }, params) {
      return ShipsService.getSLAList(params).then(
        (result) => {
          commit("storeSLAList", result.data.data);
          return Promise.resolve(result);
        },
        (error) => {
          commit("errorToast", error);
          return Promise.reject(error.response);
        }
      );
    },
    getCasesList({ commit }, params) {
      return ShipsService.getCases(params).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          commit("errorToast", error);
          return Promise.reject(error.response);
        }
      );
    },
    updateSLA({ commit }, params) {
      return ShipsService.updateSLA(params).then(
        (result) => Promise.resolve(result),
        (error) => {
          commit("errorToast", error);
          return Promise.reject(error.response);
        }
      );
    },
    createSLA({ commit }, params) {
      return ShipsService.createSLA(params).then(
        (result) => Promise.resolve(result),
        (error) => {
          commit("errorToast", error);
          return Promise.reject(error.response);
        }
      );
    },
    updateOrCreateDefinition({ commit }, params) {
      return ShipsService.updateOrCreateDefinition(params).then(
        (result) => Promise.resolve(result),
        (error) => {
          commit("errorToast", error);
          return Promise.reject(error);
        }
      );
    },
    getSystemsForShip({ commit }, params) {
      return ShipsService.getSystemsForShip(params).then(
        (result) => Promise.resolve(result),
        (error) => {
          commit("errorToast", error);
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {
    storeMaintainers(state, maintainers) {
      state.maintainers = maintainers;
      if (state.selectedMaintainer.name === null) {
        state.selectedMaintainer = maintainers[0];
      }
    },
    selectMaintainer(state, maintainer) {
      state.selectedMaintainer = maintainer;
    },
    storeShips(state, data) {
      state.ships[data.maintainer] = data.ship;
      state.ships[data.maintainer].forEach((x) => {
        x.maintainer = data.maintainer;
      });
    },
    storeShipsAll(state, data) {
      state.ships_all[data.maintainer] = data.ship;
      state.ships_all[data.maintainer].forEach((x) => {
        x.maintainer = data.maintainer;
      });
    },
    storeShipWatchdogKpi(state, data) {
      const kpi = data.kpi === "No Data" ? null : data.kpi;
      const ship = state.ships[data.maintainer][data.index];
      Object.assign(ship, {
        ...ship,
        watchdog_kpi: kpi,
        watchdog_kpi_loaded: true,
        exclusion_active: data.exclusion,
      });
    },
    storeShipWatchdogExclusions(state, data) {
      const ship = state.ships[data.maintainer][data.index];
      ship.watchdog_exclusions = data.exclusions;
      this.commit("service/updateExclusionActive", data);
      ship.watchdog_exclusions_loaded = true;
    },
    storeShipTickets(state, data) {
      const ship = state.ships[data.maintainer][data.index];
      Object.assign(ship, {
        ...ship,
        tickets: data.tickets,
        tickets_length: data.tickets?.length ?? 0,
        tickets_loaded: true,
      });
    },
    storeShipCases(state, data) {
      const ship = state.ships[data.maintainer][data.index];
      Object.assign(ship, {
        ...ship,
        cases: data.cases,
        cases_loaded: true,
        cases_length: data.cases?.length ?? 0,
      });
    },
    storeShipSystems(state, data) {
      const ship = state.ships[data.maintainer][data.index];
      Object.assign(ship, {
        ...ship,
        systems: data.systems,
        systems_names: data.systems.map((x) => x.name),
        systems_loaded: true,
        systems_length: data.systems?.length ?? 0,
      });
    },
    storeShipHardware(state, data) {
      const ship = state.ships[data.maintainer][data.index];
      Object.assign(ship, {
        ...ship,
        hardware: data.hardware,
        hardware_names: data.hardware.map((x) => x.name),
        hardware_loaded: true,
        hardware_length: data.hardware?.length ?? 0,
      });
    },
    storeShipSoftware(state, data) {
      const ship = state.ships[data.maintainer][data.index];
      Object.assign(ship, {
        ...ship,
        software: data.software,
        software_names: data.software.map((x) => x.name),
        software_loaded: true,
        software_length: data.software?.length ?? 0,
      });
    },
    storeShipCasesHistory(state, data) {
      const index = state.ships[data.maintainer].findIndex(
        (ship) => ship.ship_id === data.ship_id
      );
      if (index !== -1) {
        const ship = state.ships[data.maintainer][data.index];
        Object.assign(ship, {
          ...ship,
          cases: data.cases,
        });
      }
    },
    storeShipSystemsHistory(state, data) {
      const index = state.ships[data.maintainer].findIndex(
        (ship) => ship.ship_id === data.ship_id
      );
      if (index !== -1) {
        const ship = state.ships[data.maintainer][index];
        Object.assign(ship, {
          ...ship,
          systems: data.systems,
          systems_length: data.systems?.length ?? 0,
        });
      }
    },
    storeShipHardwareHistory(state, data) {
      const index = state.ships[data.maintainer].findIndex(
        (ship) => ship.ship_id === data.ship_id
      );
      if (index !== -1) {
        const ship = state.ships[data.maintainer][index];
        Object.assign(ship, {
          ...ship,
          hardware: data.hardware,
          hardware_length: data.hardware?.length ?? 0,
        });
      }
    },
    storeShipSoftwareHistory(state, data) {
      const index = state.ships[data.maintainer].findIndex(
        (ship) => ship.ship_id === data.ship_id
      );
      if (index !== -1) {
        const ship = state.ships[data.maintainer][index];
        Object.assign(ship, {
          software: data.software,
          software_length: data.software?.length ?? 0,
        });
      }
    },
    storeShipExclusionsHistory(state, data) {
      const index = state.ships[data.maintainer].findIndex(
        (ship) => ship.ship_id === data.ship_id
      );
      if (index !== -1) {
        const ship = state.ships[data.maintainer][index];
        Object.assign(ship, { ...ship, watchdog_exclusions: data.exclusions });
        data.index = index;
        this.commit("service/updateExclusionActive", data);
      }
    },
    storeSLAList(state, data) {
      state.sla_licenses_list = data;
    },
    updateExclusionActive(state, data) {
      let index = null;
      if (data.index === undefined || data.index === null) {
        index = state.ships[data.maintainer].findIndex(
          (ship) => ship.ship_id === data.ship_id
        );
      } else {
        index = data.index;
      }
      const now = new Date();
      let counter = 0;
      const ship = state.ships[data.maintainer][index];
      ship.watchdog_exclusions?.forEach((x, index2) => {
        //console.log("check: ",index2, state.ships[data.maintainer][index].watchdog_exclusions[index2]);
        if (x.start_time == null) {
          return;
        }
        const start = new Date(x.start_time);
        if (start <= now && x.end_time == null) {
          ship.watchdog_exclusions[index2].active = true;
          counter++;
          return;
        }
        const end = new Date(x.end_time);
        if (now >= start && now <= end) {
          ship.watchdog_exclusions[index2].active = true;
          counter++;
        }
      });
      ship.exclusion_active = counter;
    },
    errorToast(state, error) {
      if (
        typeof error === "object" &&
        "response" in error &&
        "data" in error.response &&
        "message" in error.response.data
      ) {
        const message = error.response.data?.message || error.message;
        state.toastData = {
          title: "Error!",
          message: message,
          type: "error",
        };
      }
    },
    messageToast(state, toast) {
      state.toastData = toast;
    },
  },
  getters: {
    maintainers: (state) => state.maintainers ?? null,
    ships: (state) => {
      let result = [];
      state.maintainers.forEach((x) => {
        result = result.concat(state.ships[x.name] ?? []);
      });
      return result ?? null;
    },
    ships_all: (state) => {
      let result = [];
      state.maintainers.forEach((x) => {
        result = result.concat(state.ships_all[x.name] ?? []);
      });
      return result ?? null;
    },
    selectedMaintainer: (state) => state.selectedMaintainer ?? null,
    get_sla_licenses_list: (state) => state.sla_licenses_list ?? [],
    toastData: (state) => state.toastData,
  },
};
